import {useLayoutEffect,useMemo,useRef,useSyncExternalStore} from 'react';
import {createDraft} from '../../browser-recovery/drafts';
import {createHoldingClient,holdingAccountKey,type HoldingClient} from '../client';
import {emptyHoldingSetup,validHoldingSetup} from '../draft';
import type {HoldingAccount} from '../types';
const clients=new Map<string,HoldingClient>();
if(typeof window!=='undefined'){
 window.addEventListener('storage',()=>clients.forEach(c=>c.refreshSaved()));
 window.addEventListener('beforeunload',e=>{if([...clients.values()].some(c=>c.snapshot().pending)){e.preventDefault();e.returnValue='';}});
}
export function useHoldingClient(base:string,a:HoldingAccount,begin?:()=>()=>void){
 const key=holdingAccountKey(base,a),live=useRef(key);live.current=key;
 useLayoutEffect(()=>{live.current=key;return()=>{live.current='';};},[key]);
 if(!clients.has(key))clients.set(key,createHoldingClient(base,a,begin));
 const client=clients.get(key)!;client.activate(()=>live.current===key);
 const state=useSyncExternalStore(client.subscribe,client.snapshot);
 return {client,...state,locked:state.busy||state.blocked||!!state.pending};
}
export function useHoldingDraft(key:string){
 const store=useMemo(()=>createDraft(key,'purchase-holding-setup-v1',emptyHoldingSetup(),validHoldingSetup),[key]),state=useSyncExternalStore(store.subscribe,store.snapshot);
 return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};
}
